import { BankMatchObjectSourceValue, BankMatchUiFlowValue, UI_SOURCE_PLATFORM, UiSourceValue } from '../enums'

export interface UiSourceTrackingHeaders {
  uiSource?: UiSourceValue
  uiFlow?: BankMatchUiFlowValue
  objectSource?: BankMatchObjectSourceValue
}

export const getUiSourceTrackingHeaders = ({ uiSource, uiFlow, objectSource }: UiSourceTrackingHeaders = {}): Record<
  string,
  string
> => ({
  'X-Platform': UI_SOURCE_PLATFORM,
  ...(uiSource && { 'X-Ui-Source': uiSource }),
  ...(uiFlow && { 'X-Ui-Flow': uiFlow }),
  ...(objectSource && { 'X-Object-Source': objectSource }),
})
